<template>
  <div class="progressBar">
    <div class="progressItem f-between" v-for="(item, index) in props.data" :key="index" :class="{'m-b-85': data.length - 1 != index}">
      <div class="f-center">
        <img :class="`progressBar-${item.status}-image`" :src="item.image" alt="">
        <div class="m-l-45 f-column">
          <div class="label">{{item.label}}</div>
          <div class="title">{{item.title}}</div>
        </div>
        <div v-if="item.barClass" :class="item.barClass"></div>
      </div>
      <div class="f-center">
        <div v-if="item.btnText" :class="`${item.status}-btn`">{{item.btnText}}</div>
      </div>
    </div>
    <div class="bar-border"></div>
  </div>
</template>

<script>
import router from '@/router'
import progressBarFulfillImage from '@/view/certification/assets/progressBar-fulfill.png'
import progressBarProcessingImage from '@/view/certification/assets/progressBar-processing.png'
import progressBarNotStartedImage from '@/view/certification/assets/progressBar-notStarted.png'


export default {
  props: {
    data: Object,
  },
  setup(props) {
    
    return { props }
  },
}
</script>

<style lang="scss">
@import '../style.scss';

.progressBar {
  position: relative;
  padding: 55px 40px 40px 62px;
  background: linear-gradient(0deg, #F5F8FF 0%, #FFFFFF 100%);
  .bar-border{
    position: absolute;
    bottom: 1px;
    left: 20px;
    right: 20px;
    height: 1px;
    background: #DDDDE5;
  }
  .progressItem{
    position: relative;
    .fulfill-bar{
      position: absolute;
      bottom: -72px;
      left: 46px;
      width: 6px;
      height: 60px;
      background-color: #21C370;
      border-radius: 3px;
    }
    .processing-bar{
      position: absolute;
      bottom: -72px;
      left: 46px;
      width: 6px;
      height: 60px;
      background-color: #2A68FF;
      border-radius: 3px;
    }

    .notStarted-bar{
      position: absolute;
      bottom: -72px;
      left: 46px;
      width: 6px;
      height: 60px;
      background-color: #DDDDE5;
      border-radius: 3px;
    }
  }
  .label{
    font-size: 24px;
    font-family: Arial;
    color: #8B949F;
  }
  .title{
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #0C1E2F;
  }
  .fulfill-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 50px;
    background: #21C370;
    border-radius: 25px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
  .processing-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 50px;
    background: #2A68FF;
    border-radius: 25px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
}
</style>